<template>
    <customModal :containersm="true" @closeModal="closeModal">
        <template #title>
            {{ $t('navigations.update cycle status') }}
        </template>

        <template #body>
            <div class="row align-items-end">

                <div class="col-md-8 form-group">
                    <label class="mb-0">{{ $t('navigations.cycle status') }}</label>
                    <select v-model="selectedStatus" class="form-select">
                        <option value="">Select</option>
                        <option v-for="item in cycleStatusOptions" :key="item.cycleStatus" :value="item.cycleStatus">
                            {{ item.cycleStatus }}
                        </option>
                    </select>
                </div>

                <div class="col-md-3 form-group">
                    <button class="save_btn px-4 w-100" @click="updateCycleStatus()">
                        {{ $t('navigations.update') }}
                    </button>
                </div>

            </div>
        </template>
    </customModal>
</template>

<script src="../CycleStatusPopUp/ChangeCycleStatusPopUp.js"></script>
